import { useLocation } from "wouter-preact";

export type NavigateFunction = (to: string, options?: NavigateOptions) => void;

interface NavigateOptions {
    replace?: boolean;
}

export function useNavigate(): NavigateFunction {
    const [location, navigate] = useLocation();

    return (to: string, opts?: NavigateOptions) => {
        // Relative to base path
        if (to.startsWith("/")) {
            navigate(to, opts);
            return;
        }

        // Relative to current location
        navigate(
            location.endsWith("/") ? location + to : `${location}/${to}`,
            opts,
        );
    };
}
